import { useEffect, useState } from "react";
import APIs from "../../APIs";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import { useDispatch } from "react-redux"; // you imported useSelector but not using it

const MyBookings = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const dispatch = useDispatch();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const user_id = userData?.user_id;

  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrders = async () => {
    try {
      if (!user_id) return;

      const res = await APIs.post(
        "booking/getDashboard",
        { user_id },
        { headers: { "Content-Type": "application/json" } }
      );

      const currentOrders =
        res.data.data.currentOrders ||
        res.data.data.currentOrders ||
        [];

      setOrders(currentOrders);
      console.log("Dashboard fetchOrders response:", res.data.data.currentOrders);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
    }
  };
const formatOrderDate = (dateStr) => {
  if (!dateStr) return "";

  // "29-09-2025 13:27:00"
  const [datePart, timePart] = dateStr.split(" ");
  const [day, month, year] = datePart.split("-");

  const formattedDate = new Date(`${year}-${month}-${day}T${timePart}`);

  if (isNaN(formattedDate)) return "";

  return formattedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
           
            <div className="col-lg-12">
              {/* Current Orders */}
              <div className="card mt-30">
                <div className="card-header bg-white">
                  <h5 className="card-title">Current Orders</h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12">
                      {orders.length > 0 ? (
                        orders.map((order, idx) => {
                          const pickup_address = `${order.pickup_location || ""}, ${order.pickup_landmark || ""}, ${order.pickup_city || ""}, ${order.pickup_country || ""}, ${order.pickup_state || ""}, ${order.pickup_zip_code || ""}`;
                          const drop_address = `${order.drop_location || ""}, ${order.drop_landmark || ""}, ${order.drop_city || ""}, ${order.drop_country || ""}, ${order.drop_state || ""}, ${order.drop_zip_code || ""}`;

                          return (
                            <div className="orders-container mb-4" key={idx}>
                              <div className="row">
                                <div className="col-md-12">
                                  <div className="selected-service">
                                    <div className="service-detail">
                                      <div className="service-icon">
                                        <img
                                          src={
                                            order.category_image ||
                                            "images/homepage-2/ihbox/icon-img-01.png"
                                          }
                                          alt="service"
                                        />
                                      </div>
                                      <div className="service-title">
                                        <h5>
                                          {order.category_name ||
                                            "Unknown Service"}
                                        </h5>
                                      </div>
                                    </div>
                                    <div className="order-price-status">
                                      <p
                                        className={`status ${
                                          order.status === "Pending" ? "bg-blue" : "bg-success"
                                        }`}
                                      >
                                        {order.status === "Pending"
                                          ? "Waiting for Admin Approval"
                                          : order.status || order.status}
                                      </p>

                                      <p className="price">
                                        {order.currency_symbol || ""}{order.total_pay_amount}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="booking-details">
                                    <div className="Order-id">
                                      <p>
                                        Booking Id :{" "}
                                        <span>{order.order_id}</span>
                                      </p>
                                    </div>
                                    <div className="Order-date">
                                      <p>
                                        Booking  Date :{" "}
                                        <span>
                                         {formatOrderDate(order.order_date)}
                                        </span>
                                      </p>

                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                  <div className="location-container">
                                    <div className="row">
                                      <div className="col-lg-6">
                                        <div className="pickup_location">
                                          <div className="locationdetails">
                                            <h5>Pickup Location</h5>
                                            <p>{pickup_address}</p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="col-lg-6">
                                        <div className="drop_location">
                                          <div className="locationdetails">
                                            <h5>Drop Location</h5>
                                            <p>{drop_address}</p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="col-md-12">
                                <div className="booking-details border-0 d-flex justify-content-between align-items-center">
                                <div className="Order-id">
                                      <p className="mb-0">
                                        Quote Id :{" "}
                                        <span>{order.quote_no}</span>
                                      </p>
                                    </div>
                                  <div className="d-flex justify-content-end gap-3">
                                    {order.status === 'Requested' || order.status === 'Submitted' ? 
                                    <button
                                      className="btn btn-outline-dark"
                                      onClick={() =>
                                        console.log(
                                          "Cancel order",
                                          order.order_id
                                        )
                                      }
                                    >
                                      Cancel Booking
                                    </button>:null}
                                    <button
                                      className="btn btn-outline-dark"
                                      onClick={() =>
                                        navigate(
                                          `/bookingdetails/${order.order_id}`
                                        )
                                      }
                                    >
                                      View Details
                                    </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : (
                      <div className="col-12 text-center my-5">
                       <img
                        src="/images/nodatafoundimg.png" // replace with your image path
                        alt="No documents found"
                        className="img-fluid mb-3"
                        style={{ maxWidth: "200px" }}
                        />
                        <p>No Bookings found.</p>
                      </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* End Current Orders */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyBookings;
